import { EventEmitter } from '@angular/core';

const REMOVE_MARKER$ = new EventEmitter<any>();
export default REMOVE_MARKER$;
